import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import FETCH from "../../../utils/fetch";
import { MODULE_API } from "../../../apis";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import linkedIcon from "../../../assets/images/DeathModuleNew/accountLink.png";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import swal from "sweetalert";
import moment from "moment";
import "../AssetsDashboard.css";
import DEATH_API from "../../../apis/death.api";
import axios from "axios";
import AddSimpleModal from "../../../components/styled-components/modal/add-simple-modal/add-simple-modal";
import { useDispatch, useSelector } from "react-redux";
import { postSetSelectedModuleName } from "../../../redux/slices/inventorySlice";
import {
  setRefreshTimeAsset,
  setRefreshTime,
} from "../../../redux/slices/itemsSlice";
import { saveAllProperties } from "../../../redux/slices/propertiesSlice";
import { Table, Tooltip } from "antd";
import { FutureAssetList } from "./FutureAssetList";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";
import { GlobalLoaderContext } from "../../../utils/GlobalLoaderContext";
export const AssetsTable = (props) => {
  const history = useHistory();
  const { runWithLoader } = useContext(GlobalLoaderContext);
  const [loading, setLoading] = useState(false);
  const [collectableLoading, setCollectableLoading] = useState(false);
  const [inventoryLoading, setInventoryLoading] = useState(false);

  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [assetsList, setAssetsList] = useState([]);
  const [collectableList, setCollectableList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [syncPayload, setSyncPayload] = useState([]);
  const [clientBanks, setClientBanks] = useState(null);

  const [refreshCount, setRefreshCount] = useState(0);
  const refreshTime = useSelector(
    (state) => state.rootReducer.itemsInfo.refreshTimeAsset
  );
  const dispatch = useDispatch();
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [cachedData, setCachedData] = useState({});
  const [total, setTotal] = useState(null);

  // collectable update working
  const [dropdownCollecatable, setDropdownCollecatable] = useState(false);

  const [modal, setModal] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [attributesFields, setAttributesFields] = useState();
  const [itemsData, setItemsData] = useState({});
  const [selectedRowData, setSelectedRowData] = useState({});
  const [selectedItemId, setSelectedItemId] = useState();
  const [selectedModuleName, setSelectedModuleName] = useState();

  const handelCloseModal = () => {
    setShowModal(false);
  };
  const getBankDetails = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBankDetails();
      setSyncPayload([]);
      let obj = [];
      let bankData = {};
      if (data && data.data) {
        const newArray = data.data.map((account) => {
          return {
            accountId: account.accountId,
            accountName: `${account.accountName}`,
            bankName: account.bankName,
            subType: account.subType,
            accountNumber: account.mask,
            accountTitle: `${account.accountName} ${account.mask}`,
            balance: account.balance,
          };
        });
        setClientBanks([
          ...newArray,
          {
            accountId: 1234,
            accountName: "cash",
            bankName: "devbank",
            subType: "debsubtype",
            accountNumber: 1122,
            accountTitle: "Cash",
            balance: 1111,
          },
        ]);

        data.data.forEach((item) => {
          if (!bankData[item.bankName]) {
            bankData[item.bankName] = [];
          }
          bankData[item.bankName].push({
            ...item,
            bankName: item.bankName,
            mask: item.mask,
          });
        });
        data.data.map((item, idx) => {
          obj.push({
            bankName: item.bankName,
            mask: item.mask,
            accessToken: item.accessToken,
          });
        });
      }
      setSyncPayload((prevState) => [...prevState, ...obj]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleItemsInfo = (obj) => {
    console.log("in func");

    const { name, value } = obj;

    if (name === "Price Paid (each)") {
      const totalPaid = itemsData["Quantity"] * value;

      itemsData["Total Paid"] = totalPaid;
      selectedRowData["Total Paid"] = totalPaid;

      const estimatedCurrentValue =
        itemsData["Quantity"] * itemsData["Total Paid"];
      itemsData["Estimated Total Current Value"] = estimatedCurrentValue;
      selectedRowData["Estimated Total Current Value"] = estimatedCurrentValue;
    } else if (name === "Update Value (Appraisal or other method, each)") {
      let estimatedCurrentValue = null;
      if (value === "" || value === 0) {
        estimatedCurrentValue = itemsData["Quantity"] * itemsData["Total Paid"];
      } else {
        estimatedCurrentValue = itemsData["Quantity"] * value;
      }

      itemsData["Estimated Total Current Value"] = estimatedCurrentValue;

      selectedRowData["Estimated Total Current Value"] = estimatedCurrentValue;
    }

    setItemsData({
      ...itemsData,
      [name]: value,
    });
    setSelectedRowData({
      ...selectedRowData,
      [name]: value,
    });
  };
  const handleItemsInfoSelect = (name, value) => {
    if (name === "Price Paid (each)") {
      const totalPaid = itemsData["Quantity"] * value;

      itemsData["Total Paid"] = totalPaid;
      selectedRowData["Total Paid"] = totalPaid;

      const estimatedCurrentValue =
        itemsData["Quantity"] * itemsData["Total Paid"];
      itemsData["Estimated Total Current Value"] = estimatedCurrentValue;
      selectedRowData["Estimated Total Current Value"] = estimatedCurrentValue;
    } else if (name === "Update Value (Appraisal or other method, each)") {
      let estimatedCurrentValue = null;
      if (value === "" || value === 0) {
        estimatedCurrentValue = itemsData["Quantity"] * itemsData["Total Paid"];
      } else {
        estimatedCurrentValue = itemsData["Quantity"] * value;
      }

      itemsData["Estimated Total Current Value"] = estimatedCurrentValue;

      selectedRowData["Estimated Total Current Value"] = estimatedCurrentValue;
    }

    setItemsData({
      ...itemsData,
      [name]: value,
    });
    setSelectedRowData({
      ...selectedRowData,
      [name]: value,
    });
  };
  const handleItemsInfoImageChange = async (obj) => {
    console.log("obj image", obj);
    try {
      setLoading(true);
      const imageName = obj.files[0];
      let uploadImg = null;
      let formData = new FormData();
      formData.append("image", imageName);

      // new code signedURL

      const name = obj.files[0].name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: obj.files[0].type,
      });
      const resupload = await axios.put(resdata.uploadUrl, obj.files[0], {
        headers: { "Content-type": obj.files[0].type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log(res);

      uploadImg = res;
      console.log(res, "upload res");
      itemsData[obj.name] = [res];
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };
  const getSelectedRowUpdate = async (id) => {
    try {
      setModal("Update Modal");
      setSelectedItemId(id);
      const selectedRow =
        assetsList &&
        assetsList.filter((data, index) => {
          if (data.id === id) {
            return data;
          }
        });
      console.log("selectedRow", id, assetsList, selectedRow);

      setSelectedRowData(selectedRow[0]);
      setSelectedModuleName(selectedRow[0].module);
      // setShowModal(true);
      setItemsData(selectedRow[0]);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchAttributes = async () => {
    try {
      setLoading(true);
      let attributesResponce = await MODULE_API.fetchAttributes(
        `${selectedModuleName}_item`
      );
      console.log("attributes responce", attributesResponce);
      setAttributesFields(attributesResponce);

      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
    setShowModal(true);
  };

  const submitData = async () => {
    if (modal === "View Modal") {
      setShowModal(false);
    } else {
      try {
        setShowModal(false);
        console.log("in items submit data", itemsData);
        setLoading(true);

        delete itemsData["Name of Asset"];
        delete itemsData["Account Type/Titled"];
        delete itemsData["Held Where"];
        delete itemsData["Monetary Value"];
        delete itemsData["Value as of Date"];
        delete itemsData["idx"];

        let itemsDataCopy = { ...itemsData };
        // itemsDataCopy["parentId"] = parentId;
        const payload = {
          clientModules: [itemsDataCopy],
        };
        console.log("payload", payload);
        if (modal === "Update Modal") {
          const res = await MODULE_API.updateClientItem(
            selectedItemId,
            itemsData
          );

          setLoading(false);
          getAllAssets();
          // fetchItems();
          // fetchItemsWithoutUnderscore();
        }
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
  };

  const deleteRow = async (id) => {
    try {
      const selectedRow =
        assetsList &&
        assetsList.filter((data, index) => {
          if (data.id === id) {
            return data;
          }
        });

      console.log("selectedRow to delete", selectedRow);
      const payload = {
        clientModules: [selectedRow[0].id],
      };

      swal({
        title: "Are you sure?",
        text: "You want to delete this item.",
        icon: "warning",
        // buttons: true,
        buttons: ["No, cancel it!", "Yes, delete it!"],
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          setLoading(true);
          let res = await MODULE_API.deleteItem(payload);
          if (res.status === 200) {
            setLoading(false);
            getAllAssets();
            swal("Deleted!", "Your item has been deleted.", "success");
          }
        } else {
          swal("Cancelled", "Your item is safe :)", "error");
        }
      });
    } catch (e) {
      console.log(e);
    }
  };
  const handleUpdateAssetStatus = async (record) => {
    setLoading(true);

    try {
      const updatedStatus = !record["Share with Financial Adviser"];

      await MODULE_API.updateClientModule(record.id, {
        "Share with Financial Adviser": updatedStatus,
      });

      await getAllAssets();

      console.log(`Asset status updated successfully for ID: ${record.id}`);
    } catch (err) {
      console.error("Failed to update asset status:", err);
    } finally {
      setLoading(false);
    }
  };

  const report_cols_assets = [
    {
      title: "Asset Type",
      dataIndex: "module",
      sorter: (a, b) =>
        a.module > b.module ? 1 : a.module === b.module ? 0 : -1,
      render: (text, record) => (
        <div>
          <div className="asset-name">{text || "--------"}</div>
        </div>
      ),
    },
    {
      title: "Name of Asset",
      dataIndex: "Name of Asset",
      sorter: (a, b) => a["Name of Asset"] > b["Name of Asset"],
      render: (text, record) => {
        const isShared = record["Share with Financial Adviser"]; // adjust based on your actual field'
        return (
          <div>
            <div style={{ color: "#5C667B", fontWeight: 500 }}>
              {text || "--------"}
            </div>
            {isShared && (
              <div style={{ color: "#1F3C88", fontWeight: 600 }}>Managed by Advisor</div>
            )}
          </div>
        );
      },
    },
    {
      title: "Account Type",
      dataIndex: "Account Type/Titled",
      key: "account",
      sorter: (a, b) =>
        a["Account Type/Titled"] > b["Account Type/Titled"]
          ? 1
          : a["Account Type/Titled"] === b["Account Type/Titled"]
          ? 0
          : -1,
      render: (record) => (record ? record : "--------"),
    },
    {
      title: "Held Where",
      dataIndex: "Held Where",
      key: "held_where",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Monetary Value",
      dataIndex: "Monetary Value",
      key: "value",
      defaultSortOrder: "descend",
      sorter: (a, b) => {
      const getValue = (rec) => {
        const monetary = +rec["Monetary Value"] || 0;
        const cash = +rec["Cash Holding"] || 0;
        const stock = +rec["Stock Value"] || 0;

        if (rec.module === "Investment Portfolio") {
          if (rec.managedBy === "Plaid") {
            // return monetary + cash + stock;
            return monetary + cash;
          }
          return cash + stock;
        }
        return monetary;
      };

      return getValue(a) - getValue(b);
    },
    render: (_, record) => {
      const monetary = +record["Monetary Value"] || 0;
      const cash = +record["Cash Holding"] || 0;
      const stock = +record["Stock Value"] || 0;

      let value = 0;

      if (record.module === "Investment Portfolio") {
        if (record.managedBy === "Plaid") {
          // value = monetary + cash + stock;
          value= (stock ? stock : monetary) + cash;
          value= monetary;
        } else {
          value = cash + stock;
        }
      } else {
        value = monetary;
      }

      return value
        ? `$ ${value.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : "--------";
    },
    },
    {
      title: "Value as of Date",
      dataIndex: "Value as of Date",
      key: "value_date",
      render: (record) =>
        record && record ? moment(record).format("MM-DD-YYYY") : "N/A",
    },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <React.Fragment>
            {record["Account Type/Titled"] !== "Collectible" ? (
              <div style={{ display: "flex" }} key={index}>
                {" "}
                <div
                  onClick={() => {
                    getSelectedRow(record.id);
                    setDropdown(!dropdown);
                  }}
                  style={{
                    cursor: "pointer",
                    marginRight: "1rem",
                    padding: "6px 16px",
                    width: "5px",
                  }}
                >
                  <img
                    src={menuIcon}
                    alt="menuIcon"
                    height={15}
                    width={4}
                  ></img>{" "}
                </div>
                {dropdown && selectedIndex === record.id && (
                  <React.Fragment>
                    <div
                      onClick={() => {
                        setDropdown(false);
                      }}
                      className=""
                      style={{
                        position: "fixed",
                        width: "100vw",
                        height: "100vh",
                        background: "black",
                        opacity: "0.1",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        zIndex: "999",
                      }}
                    ></div>

                    <div class="dropdown" style={{ zIndex: "9999" }}>
                      <ul className="dropdownul">
                        <li
                          className="liHover"
                          onClick={() => {
                            if (record["Account Type/Titled"] === "PROPERTY") {
                              history.push(`/inventory_new`);
                            } else {
                              fnView(record);
                            }
                            setDropdown(false);
                          }}
                        >
                          View
                        </li>
                        <li
                          className="liHover"
                          // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                          onClick={() => {
                            if (record["Account Type/Titled"] === "PROPERTY") {
                              history.push(`/inventory_new`);
                            } else {
                              fnEdit(record);
                            }
                            setDropdown(false);
                          }}
                        >
                          Update
                        </li>
                        {(userRole == "financial adviser client" || userRole == "Active financial adviser client") && (
                          <li
                            className="liHover"
                            // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                            onClick={() => {
                              handleUpdateAssetStatus(record);
                              setDropdown(false);
                            }}
                          >
                            {record["Share with Financial Adviser"]
                              ? "Not managed by Advisor"
                              : "Managed by Advisor"}
                          </li>
                        )}
                        <li
                          className="liHover"
                          // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                          onClick={() => {
                            if (record["Account Type/Titled"] === "PROPERTY") {
                              setCachedData({});
                              dispatch(saveAllProperties([]));
                              deletePost(record.id);
                              // history.push(`/inventory_new`);
                            } else {
                              setCachedData({});
                              deletePost(record.id, record.managedBy, record);
                            }
                            setDropdown(false);
                          }}
                        >
                          Delete
                        </li>
                      </ul>
                    </div>
                  </React.Fragment>
                )}{" "}
                {/*record.managedBy === "Plaid" && (
                  <div className="managed-by-plaid-icon"> </div>
                  
                )*/}
              </div>
            ) : (
              <div
                onClick={() => {
                  getSelectedRowUpdate(record.id);
                  setDropdownCollecatable(!dropdownCollecatable);
                }}
                style={{ display: "flex" }}
                key={index}
              >
                <div
                  style={{
                    cursor: "pointer",
                    marginRight: "1rem",
                    padding: "6px 16px",
                    width: "5px",
                  }}
                >
                  <img
                    src={menuIcon}
                    alt="menuIcon"
                    height={15}
                    width={4}
                  ></img>{" "}
                </div>
                {dropdownCollecatable && selectedItemId === record.id && (
                  <React.Fragment>
                    <div
                      onClick={() => {
                        setDropdownCollecatable(false);
                      }}
                      className=""
                      style={{
                        position: "fixed",
                        width: "100vw",
                        height: "100vh",
                        background: "black",
                        opacity: "0.1",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        zIndex: "999",
                      }}
                    ></div>

                    <div class="dropdown" style={{ zIndex: "9999" }}>
                      <ul className="dropdownul">
                        <li
                          className="liHover"
                          onClick={() => {
                            // setModal("View Modal")
                            // fetchAttributes();
                            setDropdownCollecatable(false);
                            if (record && record["Name of Asset"]) {
                              dispatch(
                                postSetSelectedModuleName(
                                  record["Name of Asset"]
                                )
                              );
                              history.push({
                                pathname: `/items/${record["Name of Asset"]}`,
                              });
                            }
                          }}
                        >
                          View
                        </li>
                        <li
                          className="liHover"
                          // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                          onClick={() => {
                            // fetchAttributes();
                            setDropdownCollecatable(false);
                            console.log("record", record);
                            if (record && record["Name of Asset"]) {
                              dispatch(
                                postSetSelectedModuleName(
                                  record["Name of Asset"]
                                )
                              );
                              history.push({
                                pathname: `/items/${record["Name of Asset"]}`,
                              });
                            }
                          }}
                        >
                          Update
                        </li>

                        <li
                          className="liHover"
                          // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                          onClick={() => {
                            // deleteRow(record.id);
                            setDropdownCollecatable(false);
                            if (record && record["Name of Asset"]) {
                              dispatch(
                                postSetSelectedModuleName(
                                  record["Name of Asset"]
                                )
                              );
                              history.push({
                                pathname: `/items/${record["Name of Asset"]}`,
                              });
                            }
                          }}
                        >
                          Delete
                        </li>
                      </ul>
                    </div>
                  </React.Fragment>
                )}{" "}
                {/*record.managedBy === "Plaid" && (
                  <div className="managed-by-plaid-icon"> </div>
                )*/}
              </div>
            )}
          </React.Fragment>
        );
      },
    },
    {
      title: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img
            style={{
              cursor: "pointer",
              width: "18px",
              height: "18px",
            }}
            src={linkedIcon}
            alt="linkedIcon"
          ></img>
        </div>
      ),
      render: (record) => {
        return (
          <div
            style={{ display: "flex", minHeight: "40px", cursor: "pointer" }}
          >
            {record.managedBy === "Plaid" && (
              <Tooltip title="This icon indicates that the account is securely linked with our trusted financial data provider, allowing for real-time balance updates and transaction synchronization. The connection enables seamless financial tracking without manual entry.">
                <div className="managed-by-plaid-icon"> </div>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  const report_cols = [
    {
      title: "Asset Type",
      dataIndex: "module",
      sorter: (a, b) =>
        a.module > b.module ? 1 : a.module === b.module ? 0 : -1,
      render: (record) => (record ? record : "--------"),
    },
    {
      title: "Name of Asset",
      dataIndex: "Name of Asset",
      sorter: (a, b) => a["Name of Asset"] > b["Name of Asset"],
      render: (record) => (record ? record : "--------"),
    },
    {
      title: "Account Type",
      dataIndex: "Account Type/Titled",
      key: "account",
      sorter: (a, b) =>
        a["Account Type/Titled"] > b["Account Type/Titled"]
          ? 1
          : a["Account Type/Titled"] === b["Account Type/Titled"]
          ? 0
          : -1,
      render: (record) => (record ? record : "--------"),
    },
    {
      title: "Held Where",
      dataIndex: "Held Where",
      key: "held_where",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Monetary Value",
      dataIndex: "Monetary Value",
      key: "value",
      defaultSortOrder: "descend",
      sorter: (a, b) => {
      const getValue = (rec) => {
        const monetary = +rec["Monetary Value"] || 0;
        const cash = +rec["Cash Holding"] || 0;
        const stock = +rec["Stock Value"] || 0;

        if (rec.module === "Investment Portfolio") {
          if (rec.managedBy === "Plaid") {
            // return monetary + cash + stock;
            return monetary + cash;
          }
          return cash + stock;
        }
        return monetary;
      };

      return getValue(a) - getValue(b);
    },
    render: (_, record) => {
      const monetary = +record["Monetary Value"] || 0;
      const cash = +record["Cash Holding"] || 0;
      const stock = +record["Stock Value"] || 0;

      let value = 0;

      if (record.module === "Investment Portfolio") {
        if (record.managedBy === "Plaid") {
          // value = monetary + cash + stock;
          // value= (stock ? stock : monetary) + cash;
          value= monetary;
        } else {
          value = cash + stock;
        }
      } else {
        value = monetary;
      }

      return value
        ? `$ ${value.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : "--------";
    },
    },
    {
      title: "Value as of Date",
      dataIndex: "Value as of Date",
      key: "value_date",
      render: (record) =>
        record && record ? moment(record).format("MM-DD-YYYY") : "N/A",
    },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <React.Fragment>
            {record["Account Type/Titled"] !== "Collectible" ? (
              <div style={{ display: "flex" }} key={index}>
                {" "}
                <div
                  onClick={() => {
                    getSelectedRow(record.id);
                    setDropdown(!dropdown);
                  }}
                  style={{
                    cursor: "pointer",
                    marginRight: "1rem",
                    padding: "6px 16px",
                    width: "5px",
                  }}
                >
                  <img
                    src={menuIcon}
                    alt="menuIcon"
                    height={15}
                    width={4}
                  ></img>{" "}
                </div>
                {dropdown && selectedIndex === record.id && (
                  <React.Fragment>
                    <div
                      onClick={() => {
                        setDropdown(false);
                      }}
                      className=""
                      style={{
                        position: "fixed",
                        width: "100vw",
                        height: "100vh",
                        background: "black",
                        opacity: "0.1",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        zIndex: "999",
                      }}
                    ></div>

                    <div class="dropdown" style={{ zIndex: "9999" }}>
                      <ul className="dropdownul">
                        <li
                          className="liHover"
                          onClick={() => {
                            if (record["Account Type/Titled"] === "PROPERTY") {
                              history.push(`/inventory_new`);
                            } else {
                              fnView(record);
                            }
                            setDropdown(false);
                          }}
                        >
                          View
                        </li>
                        <li
                          className="liHover"
                          // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                          onClick={() => {
                            if (record["Account Type/Titled"] === "PROPERTY") {
                              history.push(`/inventory_new`);
                            } else {
                              fnEdit(record);
                            }
                            setDropdown(false);
                          }}
                        >
                          Update
                        </li>

                        <li
                          className="liHover"
                          // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                          onClick={() => {
                            if (record["Account Type/Titled"] === "PROPERTY") {
                              setCachedData({});
                              dispatch(saveAllProperties([]));
                              deletePost(record.id);
                              // history.push(`/inventory_new`);
                            } else {
                              setCachedData({});
                              deletePost(record.id, record.managedBy, record);
                            }
                            setDropdown(false);
                          }}
                        >
                          Delete
                        </li>
                      </ul>
                    </div>
                  </React.Fragment>
                )}{" "}
                {/*record.managedBy === "Plaid" && (
                  <div className="managed-by-plaid-icon"> </div>
                  
                )*/}
              </div>
            ) : (
              <div
                onClick={() => {
                  getSelectedRowUpdate(record.id);
                  setDropdownCollecatable(!dropdownCollecatable);
                }}
                style={{ display: "flex" }}
                key={index}
              >
                <div
                  style={{
                    cursor: "pointer",
                    marginRight: "1rem",
                    padding: "6px 16px",
                    width: "5px",
                  }}
                >
                  <img
                    src={menuIcon}
                    alt="menuIcon"
                    height={15}
                    width={4}
                  ></img>{" "}
                </div>
                {dropdownCollecatable && selectedItemId === record.id && (
                  <React.Fragment>
                    <div
                      onClick={() => {
                        setDropdownCollecatable(false);
                      }}
                      className=""
                      style={{
                        position: "fixed",
                        width: "100vw",
                        height: "100vh",
                        background: "black",
                        opacity: "0.1",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        zIndex: "999",
                      }}
                    ></div>

                    <div class="dropdown" style={{ zIndex: "9999" }}>
                      <ul className="dropdownul">
                        <li
                          className="liHover"
                          onClick={() => {
                            // setModal("View Modal")
                            // fetchAttributes();
                            setDropdownCollecatable(false);
                            if (record && record["Name of Asset"]) {
                              dispatch(
                                postSetSelectedModuleName(
                                  record["Name of Asset"]
                                )
                              );
                              history.push({
                                pathname: `/items/${record["Name of Asset"]}`,
                              });
                            }
                          }}
                        >
                          View
                        </li>
                        <li
                          className="liHover"
                          // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                          onClick={() => {
                            // fetchAttributes();
                            setDropdownCollecatable(false);
                            console.log("record", record);
                            if (record && record["Name of Asset"]) {
                              dispatch(
                                postSetSelectedModuleName(
                                  record["Name of Asset"]
                                )
                              );
                              history.push({
                                pathname: `/items/${record["Name of Asset"]}`,
                              });
                            }
                          }}
                        >
                          Update
                        </li>

                        <li
                          className="liHover"
                          // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                          onClick={() => {
                            // deleteRow(record.id);
                            setDropdownCollecatable(false);
                            if (record && record["Name of Asset"]) {
                              deleteCollection(record)
                              // dispatch(
                              //   postSetSelectedModuleName(
                              //     record["Name of Asset"]
                              //   )
                              // );
                              // history.push({
                              //   pathname: `/items/${record["Name of Asset"]}`,
                              // });
                            }
                          }}
                        >
                          Delete
                        </li>
                      </ul>
                    </div>
                  </React.Fragment>
                )}{" "}
                {/*record.managedBy === "Plaid" && (
                  <div className="managed-by-plaid-icon"> </div>
                )*/}
              </div>
            )}
          </React.Fragment>
        );
      },
    },
  ];

  const getAssetsList = async (page) => {
    if (cachedData && cachedData[page]) {
      // Use cached data
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Asset&page=${page}&limit=10&clientId=${ID}`
            : `?module=Asset&page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        // setAssetsList(datares.records);
        // Cache the data for the current page
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAssetsListAfterDelete = async (page) => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
            ? `?module=Asset&page=${page}&limit=10&clientId=${ID}`
            : `?module=Asset&page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        // setAssetsList(datares.records);
        // Cache the data for the current page
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const updateStateWithData = (datares) => {
    if (datares && datares.records) {
      setAssetsList(datares.records);
    }
    if (datares && datares.pagination) {
      setTotal(datares.pagination.total);
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };
  const getCollectablesList = async () => {
    try {
      setCollectableLoading(true);
      let datares = await DEATH_API.getCollectableValues();
      if (datares && datares.message) {
        const summedValues = {};
        const assetList = [];
        datares.message.forEach((item, idx) => {
          const assetObject = {
            module: "Collectible",
            "Name of Asset": item.sub_type,
            "Account Type/Titled": "Collectible",
            "Held Where": null,
            "Monetary Value": item.monetary, // Use the summed value for this module
            "Value as of Date": null,
            idx: idx + 1, // Ensure `idx` is provided by forEach
            id: idx + 1, // Use the same index for `id`
          };
          assetList.push(assetObject);
        });

        // const assetObject = {
        //   module: "Collectible",
        //   "Name of Asset": moduleName,
        //   "Account Type/Titled": "Collectible",
        //   "Held Where": null,
        //   "Monetary Value": summedValues[moduleName], // Use the summed value for this module
        //   "Value as of Date": null,
        //   idx: idx + 1,
        //   id: idx + 1,
        // };
        // assetList.push(assetObject);

        // console.log("Summed values:", summedValues);

        // Object.keys(summedValues).forEach((moduleName, idx) => {
        //   const assetObject = {
        //     module: "Collectible",
        //     "Name of Asset": moduleName,
        //     "Account Type/Titled": "Collectible",
        //     "Held Where": null,
        //     "Monetary Value": summedValues[moduleName], // Use the summed value for this module
        //     "Value as of Date": null,
        //     idx: idx + 1,
        //     id: idx + 1,
        //   };
        //   assetList.push(assetObject);
        // });

        console.log("Assets list:", assetList);
        setCollectableList(assetList);
        // setCollectableList((prevState) => [...prevState, ...assetList]);

        // datares.records.map(
        //   (item, idx) => (
        //     (item["Name of Asset"] = item["Item Name"]),
        //     (item["Account Type/Titled"] = "Collectible"),
        //     (item["Held Where"] = item["Storage Location"]),
        //     (item["Monetary Value"] = item["Estimated Total Current Value"]),
        //     (item["Value as of Date"] = item["Update Date"]),
        //     (item["idx"] = idx + 1)
        //   )
        // );
        // console.log("datares data after", datares.records);
        // setAssetsList((prevState) => [...prevState, ...datares.records]);
        // setAssetsList(datares.records);
      }
      setCollectableLoading(false);
    } catch (error) {
      console.log(error);
      setCollectableLoading(false);
    }
  };
const getInventoryList = async () => {
    try {
      setInventoryLoading(true);
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=PROPERTY&page=1&limit=20&clientId=${ID}`
            : `?module=PROPERTY&page=1&limit=20`,
        body: {},
      });
      if (datares && datares.records) {
        datares.records.map(
          (item, idx) => (
            (item["Name of Asset"] = item.name),
            (item["Account Type/Titled"] = item.module),
            (item["Held Where"] = item.city),
            (item["Monetary Value"] = item.total),
            // (item["Value as of Date"] = item["Update Date"]),
            (item["idx"] = idx + 1)
          )
        );
        console.log("datares data after", datares.records);
        setPropertyList(datares.records);
        // setPropertyList((prevState) => [...prevState, ...datares.records]);
        // setAssetsList(datares.records);
      }
      console.log("datares inventory", datares);
      setInventoryLoading(false);
    } catch (error) {
      console.log(error);
      setInventoryLoading(false);
    }
  };
  const deleteLinkTransactions = async (id, record) => {
    await swal({
      title: "Are you sure?",
      text: `Are you sure you want to delete ${
        record["Name of Asset"] ? record["Name of Asset"] : "Asset"
      } ? All Transactions in Budget will be deleted as well.`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          setLoading(true);
          let payload = {
            cmId: id,
          };
          const resposnse = await DEATH_API.deleteLinkTransactions(payload);
          if (resposnse && resposnse.status === 200) {
            swal("Success", resposnse.message, "success");
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      } else {
        swal("Cancelled", "Your Transactions are safe :)", "error");
      }
    });
  };
  const deletePost = async (id, managedBy, recordToDelete) => {
    console.log("delete is", id);
    await swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setLoading(true);
        try {
          if (managedBy === "Plaid") {
            await deleteLinkTransactions(id, recordToDelete);
          }
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          if (recordToDelete && recordToDelete["Income Id"]) {
            const incomeDeleteRes = await MODULE_API.removeClientModule({
              clientModules: [recordToDelete["Income Id"]],
            });
          }
          // if (res && res.status === 200 && managedBy === "Plaid") {
          //   await deleteLinkTransactions(id, recordToDelete);
          // }
          setAssetsList([]);
          props.updateSharedState(!props.sharedState);
          await getAllAssets();
          // return res;
        } catch (error) {
          setLoading(false);
        }
      }
    });
  };
  
  const deleteCollection = async (recordToDelete) => {
    await swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setCollectableLoading(true);
        try {
          const res = await MODULE_API.deleteCollectable(recordToDelete["Name of Asset"]);
          // setAssetsList([]);
          props.updateSharedState(!props.sharedState);
          await getCollectablesList();
        } catch (error) {
          setCollectableLoading(false);
        }
      }
    });
  };

  const fnEdit = (record) => {
    history.push(`/assets_new/attributes/${record.module}/${record.id}`);
  };
  const fnView = (record) => {
    history.push(`/assets_new/attributes/${record.module}/${record.id}/view`);
  };
  useEffect(() => {
    // getAssetsList();
    // getCollectablesList();
    getAllAssetsFirst(currentPage);
    if (!clientBanks) {
      getBankDetails();
    }
  }, [currentPage]);
  // const getAllAssetsFirst = async (currentPage) => {
  //   await getRefreshCount();
  //   setAssetsList([]);
  //   if (currentPage) {
  //     await getAssetsList(currentPage);
  //   } else {
  //     setCachedData({});
  //     await getAssetsListAfterDelete(1);
  //   }
  //   getCollectablesList();
  //   getInventoryList();
  // };
  const getAllAssetsFirst = async (currentPage) => {
    await runWithLoader(async () => {
      await getRefreshCount();
      setAssetsList([]);

      if (currentPage) {
        await getAssetsList(currentPage);
      } else {
        setCachedData({});
        await getAssetsListAfterDelete(1);
      }

      await getCollectablesList();
      await getInventoryList();
       }, () => {
    // 👇 This runs only if global loader actually shows after 4s
    setLoading(false);
  });
  };
  const getAllAssets = async (currentPage) => {
    await getRefreshCount();
    setAssetsList([]);
    if (currentPage) {
      await getAssetsList(currentPage);
    } else {
      setCachedData({});
      await getAssetsListAfterDelete(1);
    }
    // await getCollectablesList();
    // await getInventoryList();
  };
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const getRefreshCount = async () => {
    console.log("calling asset refresh");
    try {
      setLoading(true);
      const response = await MODULE_API.assetRefreshCount(
        "/plaid-service/asset/refresh"
      );
      if (response && response && response.status === 200) {
        setRefreshCount(response.count);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  const updatePayment = () => {
    history.push("/payment");
  };
  const refreshModule = async () => {
    try {
      if (userRole && userRole === "FreeTrail") {
        history.push("/payment");
      } else {
        setLoading(true);
        if (syncPayload && syncPayload.length > 0) {
          const refreshData = await DEATH_API.refreshBanksData(
            syncPayload && { accounts: syncPayload }
          );
        }
        const response = await MODULE_API.refreshAssetModule();
        const liabiltyResponse = await DEATH_API.refreshLiability();

        if (
          response &&
          response.status === 200 &&
          response.updatedAt &&
          response.updatedAt
        ) {
          // getAllAssets();
          dispatch(setRefreshTimeAsset(response.updatedAt));
          await handleUpdateMonetaryValue();
          setAssetsList([]);
          props.updateSharedState(!props.sharedState);
          getAllAssets();
        }
        if (liabiltyResponse && liabiltyResponse.status === 200) {
          dispatch(
            setRefreshTime(
              liabiltyResponse.updatedAt && liabiltyResponse.updatedAt.updatedAt
                ? liabiltyResponse.updatedAt.updatedAt
                : new Date()
            )
          );
        }
        console.log("response", response);
        if (response && response.status === "ERROR") {
          swal({
            title: "Please Upgrade for a complete experience.",
            text: "Your level of subscription only allows for three Refreshes per day.",
            icon: "warning",
            type: "warning",
            buttons: {
              upgrade: {
                text: "Upgrade",
                value: "upgrade",
                visible: true,
              },
              ok: {
                text: "Ok",
                value: "ok",
                visible: true,
              },
            },
          }).then((value) => {
            console.log("Button value clicked:", value); // Debugging line to show the value
            switch (value) {
              case "upgrade":
                console.log("calling upgrade");
                updatePayment();
                break;

              case "ok":
                console.log("calling ok");
                break;

              default:
                console.log("No action taken");
                break;
            }
          });
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  function calculateMonetoryValue(asset) {
    const currentDate = new Date();
    let Start =
      (asset["Cost Basis Date"] && new Date(asset["Cost Basis Date"])) ||
      new Date();
    const differenceInMs = currentDate.getTime() - Start.getTime();
    const daysDifference = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
    let totalDays = daysDifference / 365;
    let Cost = +asset["Cost Basis"] || 0;
    let ReturnRate = +asset["Static"] || 0;
    let decimalValue = ReturnRate ? ReturnRate / 100 : 0;
    const amount = 1 + decimalValue / 365;
    let power = Math.pow(amount, totalDays * 365);
    const estimateDiff = Cost * power;
    if (estimateDiff > 0 && !isNaN(estimateDiff)) {
      return parseFloat(estimateDiff).toFixed(2);
    } else {
      return 0;
    }
  }
  const handleUpdateMonetaryValue = async () => {
    const filteredAssets =
      assetsList &&
      assetsList.filter((asset) => {
        return (
          (asset.subType === "Investment" || asset.subType === "Physical") &&
          asset.managedBy !== "Plaid"
        );
      });
    const updates =
      filteredAssets &&
      filteredAssets.map((asset) => {
        // Calculate the monetary value for the current asset
        if (
          asset["Cost Basis Date"] &&
          asset["Cost Basis"] &&
          asset["Static"]
        ) {
          const monetaryValue = calculateMonetoryValue(asset);

          // Return the object to be used for the API update
          return {
            id: asset.id,
            "Monetary Value": +monetaryValue,
            "Value as of Date": new Date(),
          };
        }
      });

    console.log("Prepared updates:", updates);
    setLoading(true);
    // Create an array of API call promises
    const updatePromises = updates.map((updateData) => {
      // Prepare the body for the API call
      if (updateData) {
        const submitBody = {
          "Monetary Value": updateData["Monetary Value"],
          "Value as of Date": updateData["Value as of Date"],
        };

        // Return the API call promise
        return MODULE_API.updateClientModule(updateData.id, submitBody);
      }
    });
    console.log("updatePromises", updatePromises);

    // Execute all API calls in parallel
    try {
      await Promise.all(updatePromises);
      setAssetsList([]);
      props.updateSharedState(!props.sharedState);
      getAllAssets();
      console.log("Successfully updated all assets");
    } catch (error) {
      console.error("Failed to update one or more assets", error);
    } finally {
      // Set loading to false regardless of success or failure
      setLoading(false);
    }
  };
  const handleButtonClick = () => {
    swal({
      title: "Please Upgrade for complete experience",
      text: "Your level of subscription only allows Refresh of non-linked Assets.",
      icon: "warning",
      type: "warning",
      buttons: {
        upgrade: {
          text: "Upgrade",
          value: "upgrade",
          visible: true,
        },
        ok: {
          text: "Ok",
          value: "ok",
          visible: true,
        },
        cancel: {
          text: "Cancel",
          value: "cancel",
          visible: true,
          closeModal: true,
        },
      },
    }).then((value) => {
      console.log("Button value clicked:", value); // Debugging line to show the value
      switch (value) {
        case "upgrade":
          console.log("calling upgrade");
          updatePayment();
          break;

        case "ok":
          console.log("calling Simple");
          // handleUpdateMonetaryValue();
          refreshModule();
          break;

        case "cancel":
          console.log("Cancel button clicked");
          // Add your cancel logic here, if needed
          break;

        default:
          console.log("No action taken");
          break;
      }
    });
  };

  return (
    <React.Fragment>
      <div className="incomeInfoMaincard" style={{ position: "relative" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <h3 className="incomecardheading">Asset Details</h3>
        {userRole && (userRole !== "FreeTrail" && userRole!=="Financial Advisor Client") && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              justifyContent: "space-between",
              gap: "1rem",
              color: "black",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                color: "black",
              }}
            >
              Refresh API's Calls Today {refreshCount}
              <button
                className="addbuttonLiablity"
                style={{ paddingInline: "1rem" }}
                onClick={() => {
                  handleButtonClick();
                  // refreshModule();
                }}
              >
                {" "}
                Refresh
              </button>
            </div>
            {refreshTime &&
              `Updated at: ${moment(refreshTime)
                .local()
                .format("MM/DD/YYYY [at] hh:mmA")}`}
          </div>
            )}
        </div>

        {/*  <List cols={report_cols} rows={assetsList && assetsList} /> */}
        <div style={{ position: "relative" }}>
          <Table
            columns={report_cols_assets}
            dataSource={assetsList && assetsList}
            pagination={{
              total: totalPages * 10, // Assuming 10 items per page
              current: currentPage,
              onChange: (page) => {
                setCurrentPage(page);
              },
              pageSize: 10, // Number of items per page
            }}
            rowClassName={(record) =>
              !record["Share with Financial Adviser"] &&
              userRole === "Financial Advisor Client"
                ? "disabled-row"
                : ""
            }
          />
          <NewLoader isLoading={loading} />
        </div>
        <div style={{ position: "relative" }}>
          <h3 className="incomecardheading">
            <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
              Collectible Details
              <ToolTipCreator name={"Assets_Collectible_Details"}/>
            </div>
          </h3>
          <Table
            columns={report_cols}
            dataSource={collectableList && collectableList}
          />
          <NewLoader isLoading={collectableLoading} />
        </div>
        <div style={{ position: "relative" }}>
          <h3 className="incomecardheading">
            <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
              Inventory Details
              <ToolTipCreator name={"Assets_Inventory_Details"}/>
            </div>
          </h3>
          <Table
            columns={report_cols}
            dataSource={propertyList && propertyList}
          />
          <NewLoader isLoading={inventoryLoading} />
        </div>
        <FutureAssetList />
        <AddSimpleModal
          show={showModal}
          close={handelCloseModal}
          modalTitle={modal === "View Modal" ? "View Item" : "Update Item"}
          fields={attributesFields}
          onChange={handleItemsInfo}
          onSelectChange={handleItemsInfoSelect}
          submitData={submitData}
          selectedRowData={selectedRowData}
          handleItemsInfoImageChange={handleItemsInfoImageChange}
        />
      </div>
    </React.Fragment>
  );
};
